export default __webpack_public_path__ + "static/cover-1-eaa91f3e36c0323d7ffb641ad5c3cefa.webp";